module.exports = __webpack_public_path__ + "media/images/konintodoke/other_services/services04-815e5a48840986900c61c2c63dd244c8.jpg";